export default __webpack_public_path__ + "static/media/ShareholderMeetingLetter.7d9cdc73.pdf";